import React, { Suspense, useEffect } from "react";
import { Route, Routes } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import "./tenant/assets/style/style.scss";
// import "bootstrap/dist/css/bootstrap.css";
// import { ParentDomainList } from "./config";
// import { ParentSiteLayout } from "./parent/Layout";
import CustomLoader from "./tenant/components/CustomeLoader";
import { config } from "./tenant/config";
import { ParentDomainList } from "./config";
import ParentTheme from "./parent";
import ChildTheme from "./tenant";
import "react-datepicker/dist/react-datepicker.css";
import { Helmet } from "react-helmet";
// import { Provider } from "react-redux";
// import { store } from "./_store";
// import CustomLoader from "./utils/commonFunctions/commonLoader";

function App() {
  const origin = window.location.origin;
  const host = window.location.hostname;

  const isStaging =
    host === "sostaging.uk" || host.endsWith(".sostaging.uk");

  // One-hour TTL cleanup for stale pending payment-intent markers.
  // /orders also clears this when the order appears settled; this is the
  // fallback for cases where the order never made it into the list.
  useEffect(() => {
    try {
      const raw = localStorage.getItem("pending_pi");
      if (!raw) return;
      const parsed = JSON.parse(raw);
      if (!parsed?.ts || Date.now() - parsed.ts > 3600 * 1000) {
        localStorage.removeItem("pending_pi");
      }
    } catch (_) {
      localStorage.removeItem("pending_pi");
    }
  }, []);

  const loadTheme = () => {
    if (ParentDomainList.includes(origin) || ParentDomainList.includes(host)) {
      return <ParentTheme />;
    } else {
      return <ChildTheme />;
    }
  };

  return (
    <>
      {isStaging && (
        <Helmet>
          <meta name="robots" content="noindex,nofollow,noarchive" />
        </Helmet>
      )}
      {loadTheme()}
    </>
  );
}

export default App;
